module.exports = __webpack_public_path__ + "static/media/schiphol-icons.b950b50b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icons/schiphol-icons.eot
// module id = 646
// module chunks = 0